// src/components/SafeLink.js

import React from "react";
import { NavLink } from "react-router-dom";

/**
 * <SafeLink to="/route" hasUnsavedChat={bool}>
 *   Some link text
 * </SafeLink>
 *
 * Preserves "active" styling by leveraging NavLink's active class.
 * If hasUnsavedChat = true, prompts before navigating.
 */
export default function SafeLink({ to, hasUnsavedChat, children }) {
  // Handler for click events
  const handleClick = (e) => {
    if (hasUnsavedChat) {
      const confirmLeave = window.confirm("You have an unsaved chat. Leave without saving?");
      if (!confirmLeave) {
        e.preventDefault(); // Prevent navigation if user cancels
      }
    }
    // If user confirms or hasUnsavedChat is false, allow navigation
  };

  return (
    <NavLink 
      to={to} 
      className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"} 
      onClick={handleClick}
      end={to === "/"} // Ensures exact match for the root path
    >
      {children}
    </NavLink>
  );
}

